export default __webpack_public_path__ + "1.18.25/static/media/LibreDataShare_Arabic.edfd9310.svg";